<template>
  <div>
    <jc-dialog
      :visible.sync="issueAccount"
      size="small"
      :title="$t('用户信息')"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="cancel"
    >
      <div>
        <jc-tabs type="border-card" @tab-click="handleClick" v-model="type">
          <jc-tab-pane name="queryMyCustomerList" :label="$t('我的客户')" v-if="!isSubCus && !isResend">
            <account-table
              v-if="type === 'queryMyCustomerList'"
              :type="'queryMyCustomerList'"
              :isResend="isResend"
              @selectedName="selected"
            ></account-table>
          </jc-tab-pane>
          <jc-tab-pane
            name="getSubDistributorList"
            :label="$t('我的渠道商')"
            v-if="!isSubCus && !isNewIssue"
          >
            <account-table
              v-if="type === 'getSubDistributorList'"
              :type="'getSubDistributorList'"
              :isResend="isResend"
              @selectedName="selected"
              @getSubCus="getSubCus"
            ></account-table>
          </jc-tab-pane>
          <jc-tab-pane
            name="querySubCustomerList"
            :label="$t('渠道商客户')"
            v-if="isSubCus && !isResend"
          >
            <account-table
              v-if="type === 'querySubCustomerList'"
              :type="'querySubCustomerList'"
              :isResend="isResend"
              :name="distributorName"
              @selectedName="selected"
            ></account-table>
          </jc-tab-pane>
        </jc-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <jc-button type="primary" @click="goBack" v-if="isSubCus">{{$t('上一步')}}</jc-button>
        <jc-button @click="cancel">{{$t('取消')}}</jc-button>
        <jc-button type="primary" @click="submit">{{$t('确定')}}</jc-button>
      </div>
    </jc-dialog>
  </div>
</template>
<script>
import AccountTable from '@/views/components/AccountTable'

export default {
  name: 'basicForm',
  props: {
    isResend: {
      type: Boolean,
      default: false
    },
    isNewIssue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      issueAccount: false,
      type: 'queryMyCustomerList',
      selectedName: '',
      isSubCus: false,
      distributorName: ''
    }
  },
  components: {
    AccountTable
  },
  watch: {
    isResend(val) {
      if (val) {
        this.type = 'getSubDistributorList'
      }
    }
  },
  created() {
    if (this.isResend) {
      this.type = 'getSubDistributorList'
    }
  },
  methods: {
    handleClick(tab) {
      this.type = tab.name
    },
    selected(val) {
      this.selectedName = val
    },
    getSubCus(name) {
      this.distributorName = name
      this.isSubCus = true
      this.type = 'querySubCustomerList'
    },
    submit() {
      this.$emit('selectedName', this.selectedName)
      this.issueAccount = false
    },
    cancel() {
      this.issueAccount = false
      this.isSubCus = false
      if (this.isResend) {
        this.type = 'getSubDistributorList'
      } else {
        this.type = 'queryMyCustomerList'
      }
    },
    goBack() {
      this.type = 'getSubDistributorList'
      this.isSubCus = false
    }
  }
}
</script>
